




























































import AppCheckbox from "@/components/AppCheckbox.vue";
import { pluck } from "@/fp";
import { computed, onMounted, ref } from "@vue/composition-api";
import Vue from "vue";
import { GeneratorReportTemplateSection } from "../data/pdf/model";

type CheckedItem = {
  id: string;
  name: string;
  icon: string;
  checked: boolean;
};

const id_and_name = pluck("id", "name");
export default Vue.extend({
  props: ["section", "l0_items"],
  components: { AppCheckbox /* , DropDown */ },
  setup(props, { emit }) {
    const info_types = ref<CheckedItem[]>([]);
    const selected_l0_items = computed(() =>
      info_types.value.filter((f) => f.checked)
    );
    const set_selected_l0_item = (
      value: Array<{
        id: string;
        name: string;
        checked: boolean;
      }>
    ) => {
      info_types.value = info_types.value.map((d) => {
        const item = value.find((f) => f.id === d.id);
        if (item) {
          d.checked = item.checked;
        }
        return d;
      });
      emit("set_selected_l0s", selected_l0_items.value.map(id_and_name));
    };

    const toggle_l0 = (l0: CheckedItem) => {
      if (
        selected_l0_items.value.length === 1 &&
        selected_l0_items.value[0].id === l0.id
      ) {
        return;
      }
      info_types.value = info_types.value.map((d) => {
        if (d.id === l0.id) {
          d.checked = !d.checked;
        }
        return d;
      });
      emit("set_selected_l0s", selected_l0_items.value.map(id_and_name));
    };

    const template_section = computed(
      () => props.section as GeneratorReportTemplateSection
    );

    onMounted(() => {
      info_types.value = (props.l0_items as CheckedItem[]).map((l) => {
        return {
          ...l,
          checked: false,
        };
      });
      if (template_section.value.parameters.includes("l0_label")) {
        const has_existing_value =
          template_section.value.parameters_values &&
          template_section.value.parameters_values["l0_label"];

        if (has_existing_value) {
          const existing_l0s = template_section.value.parameters_values![
            "l0_label"
          ]!;
          console.log("existing_l0s:", existing_l0s);
          set_selected_l0_item(
            existing_l0s.map((d) => ({ ...d, checked: true }))
          );
        } else {
          set_selected_l0_item([info_types.value[0]]);
          emit("set_selected_l0s", [id_and_name(info_types.value[0])]);
        }
      }
    });
    return {
      info_types,
      selected_l0_items,
      toggle_l0,
      set_selected_l0_item,
    };
  },
});
